var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0938 8.375C16.0938 12.7944 12.4808 16.375 8.09375 16.375C3.6744 16.375 0.09375 12.7944 0.09375 8.375C0.09375 3.9879 3.6744 0.375 8.09375 0.375C12.4808 0.375 16.0938 3.9879 16.0938 8.375ZM7.15827 12.6331L13.0938 6.69758C13.2873 6.50403 13.2873 6.14919 13.0938 5.95565L12.3518 5.24597C12.1583 5.02016 11.8357 5.02016 11.6421 5.24597L6.80343 10.0847L4.5131 7.82661C4.31956 7.60081 3.99698 7.60081 3.80343 7.82661L3.06149 8.53629C2.86794 8.72984 2.86794 9.08468 3.06149 9.27823L6.41633 12.6331C6.60988 12.8266 6.96472 12.8266 7.15827 12.6331Z",
    fill: "#0085E9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.4fb926b3287f1bab16e0f5e20073d6cc.svg";
export { ForwardRef as ReactComponent };